import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
//Redux
import { useDispatch } from "react-redux";
//Components
import { Input, translateMessage } from "@delibrandev/utils";
import { AiOutlineEyeInvisible } from "react-icons/ai";
//Styles
import "./style.css";
import "./responsive.css";
import { resetPassword } from "../../api/login";
import { setAlert } from "../../reducers/userConfigSlice";

export default function RecoverPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { token } = useParams();
  const [passwordChanged, setPasswordChanged] = useState(false);

  const goToHome = () => {
    navigate("/");
  };

  const handlePassword = async () => {
    const password = document.getElementById("passwordInput").value;
    const data = {
      code: token,
      newPassword: password,
    };
    console.log("data");
    console.log(data);
    const response = await resetPassword(data);
    console.log(response);
    if (response && !response.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      setPasswordChanged(true);
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
  };

  const NewPassword = () => {
    return (
      <>
        <div className="authLoginArea pt-4">
          <div className="titleLogin pt-4">Cambio de contraseña</div>
        </div>
        <div className="emailLoginArea">
          <p className="labelLogin">Nueva clave</p>
          <Input
            id={"passwordInput"}
            type={"password"}
            placeholder=""
            disabled={""}
            onKeyPress={() => null}
            icon={<AiOutlineEyeInvisible />}
            iconType={"tooglePasswordVisibility"}
            classname={""}
          />
          <button className="button-1  mt-3" onClick={handlePassword}>
            Actualizar clave
          </button>
        </div>
      </>
    );
  };

  return (
    <div className="loginArea pt-4">
      <div className="topSide">
        {/*<div className="logoContainer">
          <img src={Logo} alt="logo" className="logoLogin" onClick={goToHome} />
          <div className="titleLogin">Actualizar contraseña</div>
        </div>*/}
        <div className="formContainer pt-4">
          <div className="loginContainer">
            <div>
              {passwordChanged ? <div className="titleLogin text-align-center">Se cambió con éxito tu contraseña</div> : <NewPassword />}
              <div
                className="mt-3 text-align-center"
                onClick={goToHome}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    goToHome();
                  }
                }}
              >
                Volver al inicio de sesión
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
